module.exports = "/_next/static/images/sponsor-shapes-7cbc4f57d2aa7be122fca3c1be94aaa8.png";